import React from "react";
import { useTranslation } from "react-i18next";
import { Skull, Package, Sparkles } from "lucide-react";

export const About = () => {
  const { t } = useTranslation();
  return (
    <section id="about" data-testid="about-section" className="relative py-24 overflow-hidden bg-zinc-950">
      <div className="absolute inset-0 opacity-25" style={{
        backgroundImage: "url(https://static.prod-images.emergentagent.com/jobs/47d8df2c-1cc3-4842-9f62-a771579034aa/images/10022dde0c30f4c36bd021c52dcf1e638506554de5795f65be21d01d7459dab9.png)",
        backgroundSize: "cover",
      }} />
      <div className="absolute inset-0 bg-gradient-to-b from-zinc-950 via-zinc-950/80 to-zinc-950" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-7 space-y-8">
          <div className="font-jp text-yellow-400 text-sm tracking-widest">大太とジャック / {t("about.eyebrow")}</div>
          <h2 className="font-heading text-5xl sm:text-7xl uppercase text-white leading-none">
            {t("about.title_1")}<br />
            <span className="text-yellow-400">{t("about.title_accent")}</span><br />
            <span className="text-white">{t("about.title_2")}</span> {t("about.title_3")}
          </h2>

          <div className="space-y-4 text-zinc-300 text-lg leading-relaxed border-l-4 border-yellow-400 pl-6">
            <p>{t("about.p1")}</p>
            <p>{t("about.p2")}</p>
            <p className="text-yellow-400/90">{t("about.p3")}</p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            {[
              { i: Skull, t: t("about.feat1_t"), d: t("about.feat1_d") },
              { i: Package, t: t("about.feat2_t"), d: t("about.feat2_d") },
              { i: Sparkles, t: t("about.feat3_t"), d: t("about.feat3_d") },
            ].map((f) => {
              const Icon = f.i;
              return (
                <div key={f.t} className="bg-zinc-900 border-2 border-zinc-800 p-5 hover:border-yellow-400 transition group">
                  <div className="bg-yellow-400 text-black w-10 h-10 flex items-center justify-center mb-3 group-hover:scale-110 transition">
                    <Icon className="w-5 h-5" strokeWidth={3} />
                  </div>
                  <div className="font-heading text-lg uppercase text-white">{f.t}</div>
                  <div className="text-xs text-zinc-400 mt-1">{f.d}</div>
                </div>
              );
            })}
          </div>
        </div>

        <div className="lg:col-span-5 relative">
          <div className="grid grid-cols-2 gap-4">
            <div className="border-4 border-yellow-400 brutal-shadow-black overflow-hidden aspect-[3/4]">
              <img src="https://static.prod-images.emergentagent.com/jobs/47d8df2c-1cc3-4842-9f62-a771579034aa/images/26ff1293e079480fc715f84d9a74464bdfc0adde292bedb6fe497464f13956a8.png"
                alt="Cyber Samurai" className="w-full h-full object-cover" />
            </div>
            <div className="border-4 border-zinc-800 overflow-hidden aspect-[3/4] mt-12">
              <img src="https://static.prod-images.emergentagent.com/jobs/47d8df2c-1cc3-4842-9f62-a771579034aa/images/fe0a6ae33bb4364ded6bca430a647db4a43ed83e04d45457b946fd45c8b3be1d.png"
                alt="Psychic Esper" className="w-full h-full object-cover" />
            </div>
          </div>
          <div className="absolute -top-6 -right-6 bg-yellow-400 text-black p-3 font-heading uppercase brutal-shadow-black rotate-3">
            <div className="text-3xl leading-none">2002</div>
            <div className="text-xs tracking-widest">EST.</div>
          </div>
        </div>
      </div>
    </section>
  );
};
